<template>
  <div class="lp-address-container">
    <div class="flex-align" style="gap:8px;margin-bottom:8px">
      <input class="lp-address-zipcode input" style="margin-bottom: 0"
             v-model="address.post_code" type="text" readonly>
      <button class="button is-primary"
              @click="openDaumPostcode" style="height: 31.5px;">주소 검색</button>
    </div>
    <input class="lp-address-detail-1 input" v-model="address.new" type="text" readonly
           :style="inputStyle" style="display:block"  @click="openDaumPostcode">
    <input :disabled="!address.sido" class="lp-address-detail-2 input"
           :value="address.detail" @input="e => inputDetail(e)" type="text"
           :placeholder="address_detail_ph" :style="inputStyle"
           @focus="address_detail_ph = ''" @blur="address_detail_ph = '상세 주소를 입력하세요.'">
  </div>
</template>

<script>

  export default {
    head: {
      script() {
        return [
          {type: 'text/javascript', src: 'https://ssl.daumcdn.net/dmaps/map_js_init/postcode.v2.js', head: true}
        ];
      }
    },
    props: {
      data: {
        type: Object
      },
      inputWidth: {
        type: String
      }
    },
    data() {
      return {
        address_detail_ph: '',
        address: {
          sido: '',
          sigungu: '',
          dong: '',
          detail: '',
          post_code: '',
          old: '',
          new: '',
          latitude: '',
          longitude: '',
          title: '',
        }
      }
    },

    created() {
      if(this.data) {
        this.address = this.data;
      }
    },
    computed: {
      inputStyle() {
        if (this.inputWidth !== undefined) {
          return 'width:' + this.inputWidth;
        }
      }
    },
    watch: {
      data(n) {
        this.address = this.data;
      },
      address: {
        handler(n) {
          this.$emit('update:data', n);
        },
        deep: true
      }
    },
    methods: {
      inputDetail(e){
        this.address.detail = e.target.value;
        this.address.full = this.address.new + ' ' + this.address.detail;
      },
      openDaumPostcode() {
        daum.postcode.load(() => {
          new daum.Postcode({
            width: 500,
            height: 600,
            popupName: 'daumPostPopup',
            oncomplete: data => {
              console.log(data, 'data_test')
              this.address.sido = data.sido;
              this.address.sigungu = data.sigungu;
              this.address.dong = data.bname;
              this.address.old = (data.jibunAddress) ? data.jibunAddress : data.autoJibunAddress;
              this.address.new = (data.roadAddress) ? data.roadAddress : data.autoRoadAddress;
              this.address.post_code = data.zonecode;
              this.address_detail_ph = "상세 주소를 입력하세요."
              this.address.full = this.address.new + ' ' + this.address.detail;

              this.setPosition();
            }
          }).open({
            left: (window.screen.width / 2) - (500 / 2),
            top: (window.screen.height / 2) - (600 / 2)
          });
        });
      },
      setPosition() {
        console.log(this.backendUrl+'/public/service/geocode?address=' + encodeURI(this.address.old));
        this.$axios.get(this.backendUrl+'/public/service/geocode?address=' + encodeURI(this.address.old))
          .then(res => {
            console.log(res);
            this.address.latitude = res.data.position.latitude;
            this.address.longitude = res.data.position.longitude;
          }).catch(err => {
            console.log(err)
        });
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .address-input
    padding 8px 12px
    font-size .9rem
    color #555
    border-radius 3px
    display block
    margin-bottom 4px
    width 380px
    border 0
    background-color #f2f7f8

  .lp-address-find-btn
    padding 4px 12px
    background #ddd
    color #666
    border-radius 3px
    font-size 0.85rem

  input
    margin-bottom 8px

</style>
